<script>
  import { nrkArrowRight } from '@nrk/core-icons'

  export let landingPageUrl
  export let showAgeSelect = true
  export let predefinedAge = undefined
  export let labelText = 'I hvilket år er du født'
  export let titleSize = 'big'

  const MAX = 2022
  const MIN = 1943
  const labelClass = `label ${titleSize}`

  let yearInput = ''

  let valid
  let validationMessage

  $: valid =
    yearInput !== undefined &&
    !isNaN(yearInput) &&
    parseInt(yearInput) >= MIN &&
    parseInt(yearInput) <= MAX
  $: validationMessage =
    yearInput && yearInput.toString().split('').length >= 4 && !valid
      ? 'Har du skrevet riktig fødselsår?'
      : ''

  const nrkInput = `nrk-input input`
</script>

<form class="form" action={landingPageUrl} method="get">
  <label for="birthyear" class={labelClass}>{labelText}</label>
  <ol class="inputwrap">
    <li class="birthyear">
      <input
        id="birthyear"
        type="number"
        class={nrkInput}
        bind:value={yearInput}
        placeholder="1990"
        min={MIN}
        max={MAX}
        name="birthyear"
      />
      <div class="validation">{validationMessage}</div>
      <button class="submit" type="submit" aria-label="Gå">
        <span aria-hidden="true">
          {@html nrkArrowRight}
        </span>
      </button>
    </li>
    {#if showAgeSelect}
      <li class="age">
        <label class="age-select-label" for="age-select">Mimre tilbake til julen da du var</label>
        <select name="age" id="age-select" class="age-select">
          <option value="7">sju år</option>
          <option value="10" selected>ti år</option>
          <option value="14">fjorten år</option>
        </select>
      </li>
    {/if}
  </ol>
  {#if typeof predefinedAge !== 'undefined'}
    <input name="age" value={predefinedAge} type="hidden" />
  {/if}
</form>

<style>
  .label {
    font-style: normal;
    font-weight: 560;
    font-size: 20px;
    line-height: 48px;
    display: block;
    text-align: center;
    margin-bottom: 15px;
    color: #fff;
  }

  .label.small {
    font-size: 20px;
  }

  .age-select-label {
    display: block;
  }

  .validation {
    position: absolute;
    text-align: center;
    font-size: 18px;
    color: #fafafa;
    width: 100%;
  }

  .inputwrap {
    position: relative;
    list-style: none;
    padding: 0;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 50px;
  }

  .input {
    display: block;
    width: 230px;
    text-align: center;
    padding: 18px 0;
    border: 1px solid #a8a8a8;
    color: #26292a;
    font-size: 30px;
    border-radius: 10px;
  }

  .birthyear {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
  }

  .age {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: #fff;
  }

  .age-select {
    font-size: 16px;
  }

  input:focus::-webkit-input-placeholder {
    opacity: 0;
  }
  input:focus::-moz-placeholder {
    opacity: 0;
  }

  input:focus:-ms-input-placeholder {
    opacity: 0;
  }

  input:focus:-moz-placeholder {
    opacity: 0;
  }

  .submit {
    cursor: pointer;
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
    box-sizing: border-box;
    border-radius: 100%;
    height: 70px;
    width: 70px;
    flex: 0 0 auto;
    line-height: 160.8%;
    font-size: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .submit span {
    position: relative;
    top: 1px;
    font-size: 26px;
  }
</style>
